import { Menu, MenuItem, Typography } from '@mui/material';
import { FunnelStatuses } from 'features/co-pilot/co-pilot.types';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  anchorEl: any | null;
  menuOpen: boolean;
  status: FunnelStatuses;
  userRole: string;
  onSaveToGlobalStore?: () => void;

  handleEditFunnel(): void;

  handleOpenRenameCampaignDialog(): void;
  handleOpenScheduleDialog?(): void;
  handleCancelSchedule?(): void;
  isScheduled?: boolean;

  handleOpenFunnelStatistics?(): void;

  handleOpenCloneCampaignDialog(): void;

  handleOpenConfirmDeleteDialog(): void;

  handleArchiveCampaign(): void;

  handleUnarchiveCampaign(): void;

  handleStopFunnel?(): void;

  handleRestartFunnel?(): void;

  handleOpenEditCampaignLinkedinAccountDialog?(): void;

  handleCloseMenu(): void;
}

const CampaignItemMenu: React.FC<Props> = ({
  anchorEl,
  menuOpen,
  status,
  userRole,
  onSaveToGlobalStore,
  handleEditFunnel,
  handleOpenRenameCampaignDialog,
  handleOpenScheduleDialog,
  handleCancelSchedule,
  isScheduled,
  handleOpenFunnelStatistics,
  handleOpenCloneCampaignDialog,
  handleOpenConfirmDeleteDialog,
  handleArchiveCampaign,
  handleUnarchiveCampaign,
  handleStopFunnel,
  handleRestartFunnel,
  handleOpenEditCampaignLinkedinAccountDialog,
  handleCloseMenu,
}) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      classes={{ list: classes.menuList, paper: classes.menuPaper }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{ paper: { style: { width: 'auto' } } }}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableAutoFocusItem={true}
      disableRestoreFocus={true}
    >
      {status !== FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleEditFunnel();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('editCampaign')}</Typography>
        </MenuItem>
      ) : null}
      {status !== FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenRenameCampaignDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('renameCampaign')}</Typography>
        </MenuItem>
      ) : null}
      {status !== FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenCloneCampaignDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('cloneCampaign')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleOpenScheduleDialog) && status === FunnelStatuses.CREATED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenScheduleDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>
            {isScheduled ? t('changeSchedule', '📅 Planung ändern…') : t('scheduleStart', '📅 Für Datum planen…')}
          </Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleCancelSchedule) && isScheduled ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleCancelSchedule();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('cancelSchedule', 'Planung aufheben')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleOpenFunnelStatistics) && status !== FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenFunnelStatistics();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('statistics')}</Typography>
        </MenuItem>
      ) : null}
      {status === FunnelStatuses.STARTED || status === FunnelStatuses.PAUSED ? null : status === FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleUnarchiveCampaign();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('unarchiveCampaign')}</Typography>
        </MenuItem>
      ) : (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleArchiveCampaign();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('archiveCampaign')}</Typography>
        </MenuItem>
      )}
      {!_.isNil(handleStopFunnel) && status !== FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleStopFunnel();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('stopCampaignFull')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleRestartFunnel) && status !== FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleRestartFunnel();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('restartCampaignFull')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleOpenEditCampaignLinkedinAccountDialog) && status !== FunnelStatuses.ARCHIVED ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenEditCampaignLinkedinAccountDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('editAndRestartFull')}</Typography>
        </MenuItem>
      ) : null}
      {(userRole === 'admin' || userRole === 'agencyadmin' || userRole === 'owner') && onSaveToGlobalStore ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            onSaveToGlobalStore();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('saveToGlobalStore')}</Typography>
        </MenuItem>
      ) : null}
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleOpenConfirmDeleteDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={cx(classes.menuItemText, 'delete')}>{t('delete')}</Typography>
      </MenuItem>
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '10px',
    maxHeight: '33vh',
    width: '100%',
    marginLeft: '8px',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(13),
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    padding: '6px 16px',
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: '#FFF',
    },
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main,
    },
  },
}));

export default CampaignItemMenu;
